import {getHexKeysInRange} from "../../coords/getHexKeysInRange";
import {getNeighborHexKeys} from "../../coords/getNeighborHexKeys";
import {isUnitFaction} from "../isUnitFaction";
import {FACTIONS} from "../../../constants/factions";
import {TERRAIN_TOKENS} from "../../../constants/tokens";
import {GOBLINS_ABILITY_RADIUS, GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY} from "../../../configs/factions/goblins";
import {hasAdjacentEnemyUnit} from "../../gameState/hasAdjacentEnemyUnit";
import {hasObstacleInPath} from "../../gameState/shooting/calculateAvailableShootingCells";

/**
 * Гексы, доступные для установки ловушки Гоблинами: радиус
 * GOBLINS_ABILITY_RADIUS от отряда И прямая видимость (нет горы/непобеждённой
 * крепости на линии — та же hasObstacleInPath, что и у соблазнения Суккубов,
 * см. calculateAvailableSeductionCells и design.md), без гор на самом целевом
 * гексе, без гексов смежных вражескому отряду (смежность включает сам гекс
 * отряда) и без гексов со своей же уже стоящей ловушкой (ловушки других
 * игроков-гоблинов не мешают).
 *
 * Единая точка правды: используется и для подсветки целей, и для обработки
 * клика — обе проверки (флаг использования способности, зажатость вплотную
 * вражеским отрядом) сделаны здесь, чтобы не дублироваться и не
 * рассинхронизироваться (см. add-goblins-faction design.md, по аналогии с
 * succubes design.md Decision 16/19).
 */
export const calculateAvailableTrapSetupCells = (
  hexes, units, goblinsTraps, selectedUnit, specialBuildings, buildingsDamage, fortressesUnderConstruction
) => {
  if (!selectedUnit
    || !isUnitFaction(selectedUnit, FACTIONS.GOBLINS)
    || selectedUnit.hasUsedAbilityThisWarPhase
    || selectedUnit.size < GOBLINS_MIN_UNIT_SIZE_FOR_ABILITY
  ) {
    return [];
  }

  if (hasAdjacentEnemyUnit(selectedUnit.hexKey, selectedUnit.ownerId, units)) {
    return [];
  }

  const candidateHexKeys = getHexKeysInRange(selectedUnit.hexKey, GOBLINS_ABILITY_RADIUS);

  return candidateHexKeys.filter(hexKey => {
    if (hexes[hexKey] === TERRAIN_TOKENS.MOUNTAIN) {
      return false;
    }

    const hasOwnTrapHere = goblinsTraps.some(
      trap => trap.hexKey === hexKey && trap.ownerId === selectedUnit.ownerId
    );
    if (hasOwnTrapHere) {
      return false;
    }

    const adjacentKeys = new Set([hexKey, ...getNeighborHexKeys(hexKey)]);
    const hasAdjacentEnemy = units.some(
      unit => unit.ownerId !== selectedUnit.ownerId && adjacentKeys.has(unit.hexKey)
    );
    if (hasAdjacentEnemy) {
      return false;
    }

    return !hasObstacleInPath(
      selectedUnit.hexKey, hexKey, hexes, specialBuildings, [], buildingsDamage, fortressesUnderConstruction
    );
  });
};
